import React from 'react';

import { LoadingOverlay } from '../../components';
import { steps } from '../constants';
import {
  Cover,
  Highlights,
  Preview,
  ProductSelection,
  SelectListings,
} from '../organisms';
import { useUpsertLookbook, stepsOrder } from '../useUpsertLookbook';
import './rc-upsert-lookbook.scss';

const showStep = (lastStep, step) => {
  const lastStepIndex = stepsOrder.indexOf(lastStep);
  const stepIndex = stepsOrder.indexOf(step);

  return stepIndex <= lastStepIndex;
};

export function UpsertLookbookTemplate() {
  const { lastStep, submitting } = useUpsertLookbook();

  return (
    <div className="rc-lb-wizard">
      <div className="upsert-lookbook">
        <div className="rc-lb-wizard__panel-header">Edit Lookbook</div>
        {showStep(lastStep, steps.LISTINGS) && <SelectListings />}
        {showStep(lastStep, steps.PRODUCTS) && <ProductSelection />}
        {showStep(lastStep, steps.HIGHLIGHTS) && <Highlights />}
        {showStep(lastStep, steps.COVER) && <Cover />}
        {showStep(lastStep, steps.PREVIEW) && <Preview />}
      </div>

      {submitting && (
        <LoadingOverlay type="submitting" text="Generating lookbook..." />
      )}
    </div>
  );
}
